import { useEffect } from 'react';
import { useLocation } from 'react-router';
import ReactPixel from 'react-facebook-pixel';

export default function WithTracker(WrappedComponent: any, options = {}) {
  const trackPage = (page: string) => {
    ReactPixel.track('PageView', page);
  };

  const HOC = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      if (!!pathname) {
        trackPage(pathname);
      }
    }, [pathname]);

    return <WrappedComponent />;
  };

  return HOC;
}
